import { IBaseEntity } from "../types/entities";
import { IBaseUser } from "../types/base/IUser";
import { UserRole } from "../types/base/IRole";

export interface WorkOrderAssignment extends IBaseEntity {
  subWorkOrder: {
    assignedUsers: any[];
    workOrder: {
      company: {
        name: string;
        id: number;
      };
      number: string;
      estimateId: number;
      companyId: number;
      status: string;
      signatureId: null;
      isDeleted: boolean;
      id: number;
      rowVersion: string;
    };
    workOrderId: number;
    number: string;
    status: string;
    startTime: string;
    endTime: string;
    calendarRecordId: number;
    isDeleted: boolean;
    id: number;
    rowVersion: string;
  };
  users: any[];
  recordType: string;
  startTime: Date;
  endTime: Date;
  isManaged: boolean;
}

export interface IAbsenceAppts extends IBaseEntity {
  users: IBaseUser[];
  roles: UserRole[];
  recordType: string;
  startTime: string;
  endTime: string;
  isManaged: boolean;
  id: number;
  rowVersion: string;
  type: string;
  title?: string;
  description?: string | null;
  isForAllUser?: boolean;
}

const mapCalendarAppts = (subWoAppts: WorkOrderAssignment[]) => {
  return subWoAppts.map((elem) => ({
    assignedUsers: elem.users,
    workOrder: elem.subWorkOrder.workOrder,
    workOrderId: elem.subWorkOrder.workOrder.id,
    number: elem.subWorkOrder.workOrder.number,
    status: elem.subWorkOrder.workOrder.status,
    startTime: elem.startTime,
    endTime: elem.endTime,
    calendarRecordId: elem.subWorkOrder.calendarRecordId,
    isDeleted: elem.subWorkOrder.workOrder.isDeleted,
    id: elem.subWorkOrder.workOrder.id,
    rowVersion: elem.subWorkOrder.workOrder.rowVersion,
    recordType: elem.recordType,
  }));
};

export default mapCalendarAppts;
